import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10 flex flex-col gap-4 justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-h-primary-500 w-full px-4 xl:max-w-[1200px]" }, /*#__PURE__*/_toDisplayString("Atividades"), -1)
const _hoisted_3 = {
  key: 0,
  class: "min-h-[500px] flex flex-col gap-4 max-w-[320px] w-full sm:max-w-[500px] md:max-w-[800px] lg:max-w-[900px] xl:max-w-[1200px]"
}
const _hoisted_4 = { class: "border-2 p-4 rounded-md flex flex-col lg:flex-row justify-center md:justify-between items-center gap-4" }
const _hoisted_5 = { class: "flex flex-col lg:flex-row gap-6" }
const _hoisted_6 = { class: "flex flex-col md:flex-row gap-6" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex flex-row items-center gap-2 w-[280px]" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Status:"), -1)
const _hoisted_10 = ["v-tooltip"]
const _hoisted_11 = {
  key: 1,
  class: "mt-10 md:mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Loader, {
      loader: _ctx.loading.activities
    }, null, 8, ["loader"]),
    (_ctx.activities.length > 0 && !_ctx.loading.activities)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (activity, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h6", null, _toDisplayString(activity.title), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: "flex flex-row items-center gap-2 w-[270px] md:justify-end",
                      innerHTML: activity.info
                    }, null, 8, _hoisted_7),
                    _createElementVNode("span", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("p", {
                        class: _normalizeClass(activity.status?.class),
                        "v-tooltip": activity.status?.tooltip
                      }, [
                        _createVNode(_component_v_icon, {
                          name: activity.status?.icon
                        }, null, 8, ["name"]),
                        _createTextVNode(" " + _toDisplayString(activity.status?.text), 1)
                      ], 10, _hoisted_10)
                    ])
                  ]),
                  _createVNode(_component_Button, {
                    class: "btn-outline",
                    label: 
                _ctx.$t('labels.generic', {
                  pt: 'Ver Atividade',
                  en: 'See Activity',
                })
              ,
                    onClick: _withModifiers(($event: any) => (_ctx.goToActivity(activity?.activityId!)), ["prevent"]),
                    iconPos: "right",
                    icon: "pi pi-chevron-right"
                  }, null, 8, ["label", "onClick"])
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.activities.length === 0 && !_ctx.loading.activities)
            ? (_openBlock(), _createBlock(_component_EmptyData, {
                key: 0,
                data: _ctx.activities.length === 0,
                title: _ctx.emptyState.title,
                label: _ctx.emptyState.description,
                image: _ctx.emptyState.image,
                imgSize: "h-40 my-10 ",
                msgSize: "w-full"
              }, null, 8, ["data", "title", "label", "image"]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.params?.total! >_ctx.params?.size )
      ? (_openBlock(), _createBlock(_component_Paginator, {
          key: 2,
          rows: _ctx.params?.size,
          totalRecords: _ctx.params?.total,
          onPage: _ctx.paginateActivities
        }, null, 8, ["rows", "totalRecords", "onPage"]))
      : _createCommentVNode("", true)
  ]))
}